(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trofeos-gallery"] && !Shopify.designMode) return;
  try {
    
function initAjGallery(root){
  root.querySelectorAll('[data-aj-gallery]').forEach(gallery=>{
    if(gallery.dataset.ready)return;
    gallery.dataset.ready='true';
    const slides=Array.from(gallery.querySelectorAll('[data-aj-slide]'));
    const carousel=gallery.querySelector('.aj-gallery__carousel');
    const counter=gallery.querySelector('[data-aj-counter]');
    let current=0;
    function showSlide(index){
      if(!slides.length)return;
      current=(index+slides.length)%slides.length;
      slides.forEach((slide,i)=>{slide.hidden=i!==current;});
      counter.textContent=(current+1)+' / '+slides.length;
      gallery.querySelector('.aj-gallery__grid').dataset.ready='true';
    }
    gallery.querySelector('[data-aj-prev]').addEventListener('click',()=>showSlide(current-1));
    gallery.querySelector('[data-aj-next]').addEventListener('click',()=>showSlide(current+1));
    gallery.querySelector('.aj-gallery__controls').hidden=slides.length<2;
    carousel.addEventListener('keydown',event=>{
      if(event.key==='ArrowLeft'){event.preventDefault();showSlide(current-1);}
      if(event.key==='ArrowRight'){event.preventDefault();showSlide(current+1);}
    });
    let touchStart;
    carousel.addEventListener('touchstart',event=>{touchStart=event.touches[0].clientX;},{passive:true});
    carousel.addEventListener('touchend',event=>{
      if(touchStart===undefined)return;
      const distance=event.changedTouches[0].clientX-touchStart;
      if(Math.abs(distance)>50)showSlide(current+(distance<0?1:-1));
      touchStart=undefined;
    },{passive:true});
    gallery.addEventListener('shopify:block:select',event=>{
      const index=slides.findIndex(slide=>slide.dataset.blockId===event.detail.blockId);
      if(index>=0)showSlide(index);
    });
    showSlide(0);
    const dialog=gallery.querySelector('dialog');
    const image=dialog.querySelector('img');
    let trigger;
    gallery.querySelectorAll('[data-aj-open]').forEach(button=>button.addEventListener('click',()=>{
      trigger=button;
      image.src=button.dataset.full;
      image.alt=button.dataset.alt;
      dialog.showModal();
    }));
    dialog.querySelector('[data-aj-close]').addEventListener('click',()=>dialog.close());
    dialog.addEventListener('click',event=>{if(event.target===dialog){const rect=dialog.getBoundingClientRect();if(event.clientX<rect.left||event.clientX>rect.right||event.clientY<rect.top||event.clientY>rect.bottom)dialog.close();}});
    dialog.addEventListener('close',()=>{image.removeAttribute('src');if(trigger)trigger.focus();});
  });
}
initAjGallery(document);
document.addEventListener('shopify:section:load',event=>initAjGallery(event.target));

  } catch(e) { console.error(e); }
})();
})();
